import { render, staticRenderFns } from "./AreaDetail.vue?vue&type=template&id=321cd961&scoped=true&"
import script from "./AreaDetail.vue?vue&type=script&lang=js&"
export * from "./AreaDetail.vue?vue&type=script&lang=js&"
import style0 from "./AreaDetail.vue?vue&type=style&index=0&id=321cd961&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321cd961",
  null
  
)

export default component.exports